module.exports = __webpack_public_path__ + "assets-cabinet/img/double-arrow-icon.f7b9a2c4.svg";